import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App.tsx';
import { LeagueSettingsProvider } from '@/context/LeagueSettingsContext';
import { UserRosterProvider } from '@/context/UserRosterContext';
import { clerkAppearance } from '@/clerkAppearance';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} appearance={clerkAppearance}>
      <UserRosterProvider>
        <LeagueSettingsProvider>
          <HelmetProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </LeagueSettingsProvider>
      </UserRosterProvider>
    </ClerkProvider>
  </React.StrictMode>,
)
